module.exports = __webpack_public_path__ + "img/26.edfbe457.webp";